<template>
  <div class="home">
    <programs-header :tabs="tabs" />
    <template v-for="programType in programTypes">
      <programs-subheader
        :amount="programsByType[programType].length"
        :i18n-code="`enumerators.programType.${programType}`"
        :key="`program-subheader--${programType}--${visibleProgramsType}`"
      />
      <programs-list
        :programs="programsByType[programType]"
        :key="`program-list--${programType}--${visibleProgramsType}`"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { i18n } from '@shared/i18n'

import ProgramsHeader from '@/components/ProgramsHeader.vue'
import ProgramsSubheader from '@/components/ProgramsSubheader.vue'
import ProgramsList from '@/components/ProgramsList.vue'

export default {
  name: 'home',
  props: {
    tabs: {
      type: Array,
      default: () => ([]),
    },
    programs: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    ...mapGetters({
      visibleProgramsType: 'visibleProgramsType',
    }),
    environment() {
      return process.env.VUE_APP_ENVIRONMENT
    },
    i18nCaption() {
      return i18n('common.continue')
    },
    programsByType() {
      return this.programs.reduce((result, program) => {
        const type = program.type
        if (!result[type]) result[type] = [] 
        result[type].push(program)
        return result
      }, {})
    },
    programTypes() {
      const { tabs } = this
      return Object.keys(this.programsByType).filter(type => {
        if (!this.visibleProgramsType) return true
        return type === this.visibleProgramsType
      }).sort((a, b) => tabs.indexOf(a) - tabs.indexOf(b))
    },
  },
  components: {
    ProgramsHeader,
    ProgramsSubheader,
    ProgramsList,
  },
}
</script>

<style lang="scss" scoped>
.home {
  background: #ffffff;
}
</style>
